define([
	"dojo/_base/declare",
	"csi/table/Copy"
], function(declare,Copy) {

	return declare(Copy, {
		idOwnerRelation: "Tests"
	});
});